<head>

  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />

  <!-- Title Tag -->
  <title>Connected Insurance | Daimler Truck Insurance Agency + GEICO</title>

  <!-- Meta Title -->
  <meta name="title" content="Freightliner® & Western Star® Truck Insurance | Save Up to 10% with GEICO® & Daimler Truck Insurance Agency" />

  <!-- Combined Meta Description including H1, H2, H3 -->
  <meta name="description" content="Connected Insurance for Freightliner® & Western Star® Drivers. Save on Commercial Truck Insurance with GEICO + Daimler Truck. Insurance savings through Detroit Connect® telematics. Save up to 10% on Freightliner® and Western Star® truck insurance with Connected Insurance from Daimler Truck Insurance Agency and GEICO." />

  <!-- Meta Keywords -->
  <meta name="keywords" content="
    connected insurance for trucks,
    freightliner truck insurance,
    western star truck insurance,
    GEICO truck insurance partnership,
    connected truck insurance savings,
    daimler truck insurance agency,
    telematics truck insurance,
    truck fleet insurance solutions,
    Detroit Connect telematics savings,
    commercial vehicle insurance discounts,
    commercial truck insurance quotes
  " />

  <style>
    .mbfs-home-hero {
      background-image: url('/static/assets/img/dtf-assets/images/redesign/BannerTest.jpg');
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
    }

    @media (max-width: 1366px) {
      .mbfs-home-hero {
        background-image: url('/static/assets/img/dtf-assets/images/redesign/Tablet.jpg');
        width: 100%;
        /* image will take full width of its container */
        height: 700px;
      }
    }

    @media (max-width: 667px) {
      .mbfs-home-hero {
        background-image: url('/static/assets/img/dtf-assets/images/redesign/Mobile.jpeg');
        width: 100%;
        height: 410px;
        background-position: center;
      }
    }

    h4 {
      color: black;
      font-family: 'corporateSRegular';
      margin: 100px 150px 100px 150px;
    }

    .mbfs-repay-banner-inner__header-title {
      font-size: 2.374rem;
    }

    footer [role=contentinfo] .mbfs-copyright {
      display: flex;
      justify-content: center;
      width: 100%;
    }

    .connected-insurance {
      max-width: 600px;
      /* limit max width */
      margin-right: auto;
      /* push it to left */
      margin-left: 160px;
      /* add some space from left */
      padding-top: 100px;
    }

    .connected-insurance h2 {
      font-family: 'corporateERegular';
      font-weight: bold;
      font-size: 60px;
      color: black;
      text-align: left;
      /* left align text */
      margin: 0 0 20px 0;
    }

    .connected-insurance p {
      font-family: 'CorporateSDemiRegular';
      font-weight: lighter;
      line-height: 1em;
      font-size: 35px;
      color: black;
      width: 400px;
      text-align: center;
      margin-left: 50px;
    }

    /* Responsive styles */
    @media (max-width: 1366px) {

      h4 {
        margin: 100px 150px 100px 150px;
      }

      .connected-insurance {
        margin-left: 80px;
        max-width: 80%;
        padding-top: 60px;
      }

      .connected-insurance p {
        width: 100%;
        font-size: 28px;
        text-align: left;
        margin: 0px;
      }

      .connected-insurance h2 {
        font-size: 48px;
      }
    }

    @media (max-width: 667px) {

      h4 {
        margin: 50px 50px 50px 50px;
        font-size: 1rem;
      }

      .mbfs-repay-banner-inner__header-title {
        font-size: 1.374rem;
      }

      .connected-insurance {
        margin: 0px 0px 0px 20px;
        max-width: 100%;
        padding-top: 40px;
      }

      .connected-insurance h2 {
        font-size: 32px;
      }

      .connected-insurance p {
        font-size: 20px;
        width: 100%;
        text-align: left;
        margin: 0px;
      }
    }
  </style>
</head>

<body>
  
<div class="dtf-insurance">

<div class="dtf-alertpage"></div>



  <!--Banner-->
  <section class="mbfs-home-hero">
    <section class="connected-insurance">
      <h2>
       Connected Insurance
      </h2>
      <p>
       Get connected and save on your insurance premiums
      </p>
    </section>
  </section>

  <section class='mbfs-repay-banner-inner' style="background-color: #00566A;">
    <div class="mbfs-repay-banner-inner__box">
      <div class="mbfs-repay-banner-inner__box--text2">
        <img src="static/assets/img/dtf-assets/images/redesign/logoTest.png" alt="Freightliner and Western Star trucks for Connected Insurance program with GEICO and Daimler Truck Insurance Agency">
      </div>
    </div>
  </section>


  <div>
    <h4>
      Daimler Truck Insurance Agency has partnered with GEICO to simplify the road to insurance savings for
      Freightliner® and Western Star® drivers.
      <br><br>
      We have developed a connected insurance solution that harnesses the power of streaming telematics data. By linking
      with Detroit Connect®, we receive vehicle data that can translate into savings for you - allowing participating 
      customers to save up to 10% on their insurance premiums, excluding fees and taxes.
    </h4>
  </div>

  <section class='mbfs-repay-banner-inner' style="background-color: #E6E6E6; display: flex; justify-content: center;">
    <div class="mbfs-repay-banner-inner__box">
      <div class="mbfs-repay-banner-inner__box--text2">
        <h5 class="mbfs-repay-banner-inner__header-title" style="color: black; ">
          Visit the link below to get your personalized quote or call <br> <a href="tel:1-800-909-1184">1-800-909-1184</a> to start saving today.
        </h5>
        <button class="mbfs-button-1" id="GEICOcta" style="background-color: #00566A;" (click)="GetQuote()">Get Quote</button>       
      </div>
    </div>
  </section>

<br>
<br>

  <footer id="mbfs-footer">
    <div role="contentinfo">
      <div class="mbfs-copyright">
        <p class="paragraph1"> {{ 'Insurance.DisclaimerConnectedInsurance' | translate }} </p>
        <p class="paragraph1"> {{ 'Insurance.Disclaimer2' | translate }} </p>
      </div>
    </div>
  </footer>

</div>

</body>